import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { BehaviorSubject, Observable, shareReplay } from "rxjs"
import { environment } from "src/environments/environment"
import {
    CostCenter,
    Node,
    EmployeeType,
    EdpData,
    toPositions,
} from "../models"
import { Positions } from "../models/dependencies/positions.model"

@Injectable({
    providedIn: "root",
})
export class DependenciesService {
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.dependencies

    private _positions: BehaviorSubject<Positions | undefined> = new BehaviorSubject<Positions | undefined>(undefined)
    private _orgUnitTree: BehaviorSubject<Node | undefined> = new BehaviorSubject<Node | undefined>(undefined)
    private _costCenters: BehaviorSubject<CostCenter[]> = new BehaviorSubject<CostCenter[]>([])
    private _employeeContracts: BehaviorSubject<EmployeeType[]> = new BehaviorSubject<EmployeeType[]>([])
    private _edpRequested = false

    constructor(private http: HttpClient) {}

    InitDependencies(): void {
        if (this._edpRequested) return
        this._edpRequested = true

        this.dependencies$.subscribe(data => {
            this._orgUnitTree.next(data.orgUnits === null ? undefined : JSON.parse(JSON.stringify(data.orgUnits)))
            this._positions.next(data.positions === null ? undefined : toPositions(data.positions))
            this._costCenters.next(data.costCenters === null ? [] : data.costCenters)
            this._employeeContracts.next(data.employeeTypes === null ? [] : data.employeeTypes)
        })
    }

    OrgUnitTree(): BehaviorSubject<Node | undefined> {
        return this._orgUnitTree
    }

    Positions(): BehaviorSubject<Positions | undefined> {
        return this._positions
    }

    CostCenters(): BehaviorSubject<CostCenter[]> {
        return this._costCenters
    }

    EmployeeContracts(): BehaviorSubject<EmployeeType[]> {
        return this._employeeContracts
    }

    private _dependencies$ = this._fetchDependencies();

    private _fetchDependencies(): Observable<EdpData> {
        return this.http.get<EdpData>(this._apiUrl + "/edp-data").pipe(
            shareReplay({ bufferSize: 1, refCount: true })
        );
    }

    get dependencies$(): Observable<EdpData> {
        return this._dependencies$;
    }
}
